import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useArtistAuth } from '@/context/ArtistAuthContext';
import { useCollaboratorAuth } from '@/context/CollaboratorAuthContext';
import { useBuyerAuth } from '@/context/BuyerAuthContext';

const EmailVerified = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { isAuthenticated: artistAuthenticated } = useArtistAuth();
  const { isAuthenticated: collaboratorAuthenticated } = useCollaboratorAuth();
  const { refreshBuyer } = useBuyerAuth();
  const status = searchParams.get('status');
  const role = searchParams.get('role');
  const isSuccess = status === 'success';
  const isExpired = status === 'expired';
  const isCollaborator = role === 'collaborator';
  const isBuyer = role === 'buyer';

  useEffect(() => {
    if (!isSuccess) return undefined;

    const timer = window.setTimeout(() => {
      if (isBuyer) {
        refreshBuyer().finally(() => window.dispatchEvent(new Event('openBuyerLogin')));
        return;
      }

      if (isCollaborator) {
        if (collaboratorAuthenticated) {
          navigate('/collaborator/account', { replace: true });
          return;
        }
        window.dispatchEvent(new Event('openCollaboratorJoin'));
        return;
      }

      if (artistAuthenticated) {
        navigate('/my-account', { replace: true });
        return;
      }
      window.dispatchEvent(new Event('openArtistJoin'));
    }, 1800);

    return () => window.clearTimeout(timer);
  }, [artistAuthenticated, collaboratorAuthenticated, isBuyer, isCollaborator, isSuccess, navigate, refreshBuyer]);

  const continueLabel = isBuyer ? 'Continue to Marketplace' : isCollaborator ? 'Continue to Collaborator Account' : 'Continue to Artist My Account';
  const openSignIn = () => {
    if (isBuyer) {
      window.dispatchEvent(new Event('openBuyerLogin'));
      return;
    }
    window.dispatchEvent(new Event(isCollaborator ? 'openCollaboratorJoin' : 'openArtistJoin'));
  };

  return (
    <main className="min-h-screen bg-gray-50 px-4 py-24">
      <section className="mx-auto max-w-2xl rounded-3xl bg-white p-8 text-center shadow-xl">
        <p className="text-sm font-bold uppercase tracking-[0.24em] text-[#FF6F00]">Kala Manch</p>
        <h1 className="mt-3 text-3xl font-bold text-gray-900">
          {isSuccess ? 'Your email has been verified' : isExpired ? 'Verification link expired' : 'Verification could not be completed'}
        </h1>
        <p className="mt-4 text-gray-600">
          {isSuccess
            ? `Your email has been verified. ${isBuyer ? 'We are opening buyer sign in so you can continue to KalaManch Market.' : `We are opening ${isCollaborator ? 'collaborator sign in' : 'artist sign in'} so you can continue to your account.`}`
            : isExpired
              ? 'Please sign in again. We will send a fresh verification link if your email is still pending.'
              : 'Please try signing in again or request a fresh verification link.'}
        </p>
        <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
          <button type="button" className="btn-primary" onClick={openSignIn}>
            {isSuccess ? continueLabel : 'Try Sign In Again'}
          </button>
          <Link to="/" className="btn-outline">Go Home</Link>
        </div>
      </section>
    </main>
  );
};

export default EmailVerified;
